<template>
  <FileDrop
    :id="id"
    accept=".jpg,.png,.jpeg"
    class="ImageDrop"
    :message="$t('uploadImage')"
    :options="options"
    :type="type"
    @isLoading="isLoading = $event"
    @success="$emit('update:file', $event.file),setImageUrl" />
</template>

<script>
import FileDrop from '@components/fields/FileDrop'

export default {
  components: {
    FileDrop,
  },
  props: {
    id: { type: String, default: 'imageDrop' },
    options: { type: Object, default: () => ({}) },
    type: { type: String, default: null },
    value: { type: String, default: null },
  },
  data() {
    return {
      isLoading: false,
    }
  },
  methods: {
    setImageUrl({ file }) {
      this.$emit('update:value', `https://${file.host}/${file.url}`)
    },
  },
}
</script>

<style lang="scss">
.ImageDrop {
}
</style>

<i18n>
{
  "en": {
    "uploadImage": "Upload image"
  }
}
</i18n>
